import { MCO_DOMAIN } from '@/libs/constant';
import { LANG } from '@/libs/translation';
import { Icon, Link } from '@/ui/component/atom';
import { getSharedData, PostMessage } from '@/ui/util';
import { html, View } from 'rune-ts';

interface LogoViewData {
  theme: 'Marpple' | 'MarppleShop' | 'Ciety';
  no_link?: boolean;
}

export class LogoView extends View<LogoViewData> {
  override template() {
    return html`<div>
      ${this.data.no_link
        ? new Icon({ name: 'logo' })
        : new Link({ label: new Icon({ name: 'logo' }), href: MCO_DOMAIN[this.data.theme] }, { klass: 'logo' })}
    </div> `;
  }

  override onRender() {
    const { theme, is_app, client_id } = getSharedData(this);
    if (is_app) {
      this.delegate('click', Link, (e) => {
        if (theme === 'Ciety') {
          e.originalEvent.preventDefault();
          e.originalEvent.stopPropagation();
          location.replace(`/${LANG}/signup?client_id=${client_id}`);
        }

        if (theme === 'MarppleShop') {
          e.originalEvent.preventDefault();
          e.originalEvent.stopPropagation();
          PostMessage.goHome();
        }
      });
    }
  }
}
